import { Component, OnInit, Inject, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { FormGroup, FormBuilder, Validators, NgForm } from '@angular/forms';
import { DOCUMENT } from '@angular/common';
import { ManikEntityFE, CookieManager } from 'src/app/manik-library/ManikEntityFE';
import { ReportBizModel, IDropDownList } from 'src/app/models/web-card-model';
import { ManikEntityService } from 'src/app/manik-library/ManikEntityService';
declare const $: any;
declare const grecaptcha: any;
@Component({
  selector: 'report-business',
  templateUrl: './report-business.component.html',
  styleUrls: ['./report-business.component.scss']
})
export class ReportBusinessComponent extends ManikEntityFE implements OnInit, OnChanges {
  ReportBizForm: FormGroup;
  ReportModel: ReportBizModel = new ReportBizModel();
  ReportReasonList: IDropDownList[];
  ContactModeList: any[];//IDropDownList[];
  WebSiteMetaData = JSON.parse(sessionStorage.getItem("SiteMetaData"));
  ReportRecaptcha: any;
  CaptchaInvalid: boolean = false;
  CaptchaMessage: string = '';
  UserLoggedIn: boolean;
  @Input() VisitorData: any;
  @Output() VisitorLoggedIn = new EventEmitter();
  constructor(private formBuilder: FormBuilder, public _manikEntityService: ManikEntityService, @Inject(DOCUMENT) public document: any) {
    super(document);
    this.ReportBizForm = this.formBuilder.group({
      ReasonID: ['', Validators.required],
      PreferredContactMode: ['', Validators.required],
      PreferredContactTime: ['', Validators.required],
      Remarks: ['', Validators.required],
      VisitorID: ['', ]
    });
  }

  ngOnInit() {
    this.populateControls();
    this.CheckUserLoggedIn();
  }

  ngOnChanges() {
    this.CheckUserLoggedIn();
  }


  populateControls(): void {
    this.ReportModel.BusinessName = this.WebSiteMetaData["Title"];//this.WebCardDetails.BUSINESSTITLE;
    this.updateFilterParams(this.WebSiteMetaData["BizHandle"]);
    this._manikEntityService.manikEntityConnect2(this.EndPoint+"entitymgr", null, this.prepareAddlQueryHeaders2("ULTRA.QUICK", "GET.REPORTING.REASONS", "PORTAL", "EMCITY"))
      .subscribe(data => {
        this.ReportReasonList = data.ManikJSon[0].JSon0;
        this.ContactModeList = data.ManikJSon[0].JSon1;
      })
  }
  CaptchaInitialized: boolean = false;

  CheckUserLoggedIn() {

    if (CookieManager.getCookie('VisitorData')) {
      let x = JSON.parse(CookieManager.getCookie('VisitorData'));
      console.log(x)
      if (x) {
        if (x.VisitorName) {
          this.UserLoggedIn = true;
          this.ReportBizForm.controls['VisitorID'].setValue(x.VisitorID);
          setTimeout(() => {
            if (!this.CaptchaInitialized) {
              this.InitCaptcha(this.ReportRecaptcha, 'reportForm', grecaptcha);
              this.CaptchaInitialized = true;
            }

          }, 1000)
        }
        else {
          this.UserLoggedIn = false;
        }
      }
      else {
        this.UserLoggedIn = false;
      }
    }
  }

  Emit() {
    this.VisitorLoggedIn.emit('Y');
  }

  refreshDataGrid(param: any): void {
    throw new Error("Method not implemented.");
  }

  SubmitToDatabase(): void {
    console.log(this.ReportBizForm.value)
    if (this.ReportBizForm.invalid) {
      return;
    }
    this.CaptchaInvalid = false;
    this.CaptchaMessage = '';
    let x = grecaptcha.getResponse(this.ReportRecaptcha);
    this._manikEntityService.manikEntityConnect2('WebSite/captcha/v2?sToken=' + x, null, null)
      .subscribe(data => {
        if (data.success) {
          this.SubmitForm();
        }
        else {
          this.CaptchaInvalid = true;
          if (data['error-codes'].find(item => {
            return item == 'missing-input-response'
          })) {
            this.CaptchaMessage = 'Please click on the checkbox';
          }
          if (data['error-codes'].find(item => {
            return item == 'timeout-or-duplicate'
          })) {
            this.CaptchaMessage = 'Please click on the checkbox again';
          }

        }
      });
  }

  SubmitForm() {
    console.log(this.ReportBizForm.value)
    if (this.ReportBizForm.invalid) {
      return;
    }
    this.ReportModel.IsSubmitted = true;

    let body = this.ReportBizForm.value;
    body["DomainName"] = location.host;
    body["BusinessHandle"] = this.WebSiteMetaData["BizHandle"];
    body["PortalIdentifier"] = this.WebSiteMetaData["PC"];

    body["DateReported"] = this.getManikDateString(new Date());
    body["ChannelID"] = "W";

    let SubmittedData = JSON.stringify({ "items": [body] });
    this._manikEntityService.manikEntityConnect2(this.EndPoint+"entitymgr", SubmittedData,
      this.prepareManageHeaders2("A", "BUSINESS.REPORTED", "MANIK.GLOBAL", this.WebSiteMetaData["PC"]))
      .subscribe(data => {
        let resp = data.ManikJSon[0];
        //rbForm.resetForm();
        this.ReportBizForm.reset();
        this.ReportModel.IsSubmitted = false;
        $("#lblReMessage").text("Your request has been submitted!");
        $("#lblReMessage").show();
        $('#lblReMessage').modal('hide');
        setTimeout(() => {
          $('#ReportBusiness').modal('hide');
        }, 5000);
      });
  }

  get rBForm() {
    return this.ReportBizForm.controls;
  }
}
